import { useTranslation } from 'react-i18next';
import { Navbar, NavbarBrand, NavbarContent, NavbarItem } from '@heroui/navbar';
import { Link } from '@heroui/link';
import { useLocation } from 'react-router-dom';

import Logo from '@/components/Logo/Logo.tsx';

function TopNavBar() {
  const [t] = useTranslation();
  const { pathname } = useLocation();

  return (
    <Navbar className="bg-content2">
      <NavbarBrand className="-ml-3 sm:ml-0">
        <Link className="text-foreground" href="/">
          <Logo />
        </Link>
      </NavbarBrand>
      <NavbarContent className="hidden sm:flex gap-4" justify="center">
        <NavbarItem isActive={pathname === '/'}>
          <Link color="foreground" href="/">
            {t('main.start')}
          </Link>
        </NavbarItem>
        <NavbarItem isActive={pathname.startsWith('/progressions')}>
          <Link color="foreground" href="/progressions">
            {t('main.progressions')}
          </Link>
        </NavbarItem>
        <NavbarItem isActive={pathname.startsWith('/songbook')}>
          <Link color="foreground" href="/songbook">
            {t('main.songbook')}
          </Link>
        </NavbarItem>
      </NavbarContent>
    </Navbar>
  );
}

export default TopNavBar;
